/*eslint-disable */

// ====================================
//  Basic Javascript helpers used in analytics.js and graphics code.
// ====================================

import { select } from 'd3-selection';

//  Convert arbitrary strings to valid css classes.
//  via: https://gist.github.com/mathewbyrne/1280286
//  NOTE: This implementation must be consistent with the Python classify
//  function defined in base_filters.py.
// ====================================
export function classify(str) {
    return str.toLowerCase()
        .replace(/\s+/g, '-')           // Replace spaces with -
        .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
        .replace(/\-\-+/g, '-')         // Replace multiple - with single -
        .replace(/^-+/, '')             // Trim - from start of text
        .replace(/-+$/, '');            // Trim - from end of text
};

export function pymMessageListener() {
    pym.onMessage('saveImage', saveImage);

    function saveImage(slug) {
        domtoimage.toJpeg(document.getElementsByTagName('body')[0], { quality: 1 })
        .then(function (dataUrl) {
            var link = document.createElement('a');
            link.download = slug + '.jpg';
            link.href = dataUrl;
            link.click();
        });
    }
};

//  Parse a url parameter by name.
//  via: http://stackoverflow.com/a/901144
// ====================================
export function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
};


//  Convert a url to a location object.
// ====================================
export function urlToLocation(url) {
    var a = document.createElement('a');
    a.href = url;
    return a;
};

//  Change styles for CNN Politics/CNN Business graphics
// ====================================
export function stylePremium(CNNPolitics, CNNBusiness) {

  if (CNNPolitics) {
    document.body.classList.add('cnn-politics');
  }

  if (CNNBusiness) {
    document.body.classList.add('cnn-business');
  }

};

export function wrapLongLabels(text, width) {
  text.each((data, index, arr) => {
    let text = select(arr[index]);
    let words = text.text().split(/\s+/).reverse();
    let word;
    let line = [];
    let lineNumber = 0;
    let lineHeight = 1.1;
    let y = text.attr("y");
    let dy = parseFloat(text.attr("dy"));
    
    let tspan = text.text(null)
        .append("tspan")
        .attr("x", 0)
        .attr("y", y);
    
    while (word = words.pop()) {
      line.push(word);
      tspan.text(line.join(" "));
    
      if (tspan.node().getComputedTextLength() > width) {
      
        line.pop();
        tspan.text(line.join(" "));
        line = [word];

        lineNumber++;
        
        tspan = text.append("tspan")
          .attr("x", 0)
          .attr("y", y)
          .attr("dy", lineHeight + "em")
          .text(word);
      }
    
    }

    if (lineNumber > 0) {
      text.select('tspan')
        .attr('dy', -0.28333 * lineNumber + 'em');
    }
  });
}
